// Legend: the 5 pollen levels with the product palette colors. Labelled
// "maximum across your selected allergens" (the shader reduces with MAX).

import type { PaletteLevel } from "../manifest";

export class Legend {
  readonly el: HTMLElement;

  constructor(levels: PaletteLevel[]) {
    this.el = document.createElement("div");
    this.el.className = "legend";
    this.el.setAttribute("role", "group");
    this.el.setAttribute("aria-label", "Pollen level legend");

    const title = document.createElement("div");
    title.className = "legend-title";
    title.textContent = "Pollen level";
    const sub = document.createElement("div");
    sub.className = "legend-sub";
    // Kept wording: the shader reduces the selected allergens with a per-pixel MAX.
    sub.textContent = "maximum across your selected allergens";
    this.el.appendChild(title);
    this.el.appendChild(sub);

    const row = document.createElement("div");
    row.className = "legend-row";
    levels
      .slice()
      .sort((a, b) => a.level - b.level)
      .forEach((l) => {
        const item = document.createElement("div");
        item.className = "legend-item";
        const sw = document.createElement("span");
        sw.className = "legend-swatch";
        sw.setAttribute("aria-hidden", "true");
        // Level 0 (none) renders transparent; show it as a hollow chip.
        if (l.level === 0) {
          sw.classList.add("legend-swatch-none");
        } else {
          sw.style.background = l.color;
        }
        const lab = document.createElement("span");
        lab.className = "legend-label";
        lab.textContent = l.label_en;
        item.appendChild(sw);
        item.appendChild(lab);
        row.appendChild(item);
      });
    this.el.appendChild(row);
  }
}
